import NextImage from "@/app/components/lib/NextImage";

interface Props {
  avatar: string;
}

const PCUserAvatar: React.FC<Props> = ({ avatar }) => {
  return (
    <div
      style={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <NextImage
        alt="user"
        src={avatar}
        width={32}
        height={32}
        objectFit="fill"
      />
    </div>
  );
};

export default PCUserAvatar;
